module.exports = __webpack_public_path__ + "img/file-icon_jpg.5196acbc.svg";